module.exports = __webpack_public_path__ + "static/media/search.b2c0f0aa.svg";